/**
  Represents a top bar component.
  @class

  @param {Element} container - The container element for the top bar.

  @property {Element} header - The header element.
  @property {Element} container - The container element for the top bar.
  @property {Element} topBarEl - The top bar element.
  @property {Element} scrollTarget - The target element for scrolling.
  @property {boolean} enable - A boolean that indicates whether the top bar is enabled.
*/

export class TopBar {
  constructor(container) {
    this.header = document.getElementById("shopify-section-header");
    this.container = container;
    this.topBarEl = document.querySelector("product-top-bar");
    this.scrollTarget = document.getElementById("productFormContainer");
    this.enable = window.innerWidth < 1024;

    this._init();
  }

  /**
    Hides the top bar element.
  */
  _hide() {
    this.topBarEl.style.height = "0";
    this.topBarEl.style.visibility = "hidden";
    this.topBarEl.style.top = "-40px";
  }

  /**
    Refreshes the top bar element based on the specified trigger element.
    @param {Element} trigger - The trigger element.
  */
  _refresh(trigger) {
    this.topBarEl = document.querySelector("product-top-bar");
    this.scrollTarget = document.getElementById("productFormContainer");

    const topImage = this.topBarEl.querySelector("#top-bar-image");
    const topTitle = this.topBarEl.querySelector("#top-bar-title");
    const topVariant = this.topBarEl.querySelector("#top-bar-id");

    topImage.src = `${trigger.dataset.image}`;
    topTitle.innerText = `${trigger.dataset.title}`;
    topVariant.value = `${trigger.dataset.variant}`;
  }

  /**
    Handles the scrolling of the page.
  */
  _handleScroll() {
    if (!this.enable) {
      return;
    }
    if (
      window.scrollY >
      this.scrollTarget.offsetHeight + this.scrollTarget.offsetTop
    ) {
      this.topBarEl.style.visibility = "visible";
      this.topBarEl.style.height = "auto";
      this.topBarEl.style.top = `${this.header.clientHeight}px`;
    } else {
      this.topBarEl.style.top = "-40px";
      setTimeout(() => {
        this.topBarEl.style.height = "0px";
        this.topBarEl.style.visibility = "hidden";
      }, 35);
    }
  }

  /**
    Initializes the top bar element and its event listeners.
  */
  _init() {
    document.addEventListener("scroll", () => this._handleScroll());

    const resizeAction = () => {
      this.enable = window.innerWidth < 1024;
      this.header = document.querySelector("header");

      if (!this.enable) {
        this._hide();
      }
    };

    window.addEventListener("resize", () => {
      const doit = setTimeout(resizeAction, 400);
      clearTimeout(doit);
    });
  }
}
